<template>
  <div class="groupActiveCodeStatistics-container">
    <div class="search-wrap">
      <el-form :inline="true">
        <el-form-item label="群码名称：">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入名称"
            size="mini"
            clearable
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="使用场景：">
          <el-input
            v-model="searchParams.sceneName"
            placeholder="请输入使用场景"
            size="mini"
            clearable
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="mini"
            @change="selectBindStatus"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <!-- <el-form-item label="创建人：">
          <el-input
            placeholder="请输入创建人"
            v-model="searchParams.creatorName"
            size="mini"
            clearable
            @change="geDatatList"
          />
        </el-form-item> -->
        <!-- <el-form-item label="使用员工：">
          <el-input
            v-model="searchParams.staffName"
            size="mini"
            clearable
            @change="geDatatList"
            placeholder="请输入使用员工"
          />
        </el-form-item> -->
        <!-- <el-form-item label="拉群方式：">
          <el-select
            v-model="searchParams.joinWay"
            placeholder="请选择"
            size="mini"
            @change="geDatatList"
            clearable
          >
            <el-option label="通过加好友进群" :value="0"></el-option>
            <el-option label="直接进群" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="状态：">
          <el-select
            v-model="searchParams.status"
            placeholder="请选择"
            size="mini"
            @change="selectBindStatus"
            clearable
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="可用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
            <el-option label="失效" :value="-1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      size="small"
      :data="tableData"
      fit
      highlight-current-row
      align="center"
      :header-cell-style="{ background: '#eef1f6' }"
      height="calc(100vh - 250px)"
      ref="cusChatTable"
      @sort-change="sortChange"
    >
      <el-table-column
        prop="name"
        label="活码名称"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="sceneName" label="使用场景" align="center">
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          <span style="color:#81bcfd" v-if="scope.row.status == 1">可用</span>
          <span style="color:#fdd554" v-if="scope.row.status == 0">停用</span>
          <span style="color:#ff6464" v-if="scope.row.status == -1">失效</span>
        </template>
      </el-table-column>
      <el-table-column prop="useTotalNum" label="使用群聊数" align="center">
      </el-table-column>
      <el-table-column
        prop="chatGroupMemberTotalNum"
        label="扫码人数"
        align="center"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="joinChatGroupTotalMemberNum"
        label="进群人数"
        align="center"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        label="退群人数"
        align="center"
        prop="exitChatGroupTotalMemberNum"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column prop="operation" label="操作" align="center">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            @click="viewDetail(scope.row)"
            type="primary"
            >查看明细</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination> -->

    <div class="staff-pagination">
      <el-pagination
        @current-change="currentChange"
        @size-change="sizeChange"
        :current-page.sync="searchParams.page"
        :page-size.sync="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchParams.total"
        :page-sizes="[20, 50, 100, 200, 500]"
      >
      </el-pagination>
    </div>

    <!-- 活码明细弹窗 -->
    <GroupActiveCodeStatisticsDetail
      ref="GroupActiveCodeStatisticsDetail"
      v-if="groupActiveCodeStatisticsDetailShow"
      @close="close"
    />
    <!-- <el-dialog
      style="height: 600px"
      title="活码明细"
      :visible.sync="tagVisible"
      :close-on-click-modal="false"
      width="30%"
      close-on-press-escape
      v-if="tagVisible"
    >
      <div>活码名称: {{ qrName }}</div>
      <div v-for="i in checkDetailList">
        <div class="title">群聊：{{ i.groupName }}</div>
        <div class="list">
          <div class="item">
            进群人数：{{
              i.joinChatGroupTotalMemberNum != null ||
              i.joinChatGroupTotalMemberNum != undefined
                ? i.joinChatGroupTotalMemberNum
                : 0
            }}
          </div>
          <div class="item">
            退群人数：{{
              i.exitChatGroupTotalMemberNum != null ||
              i.exitChatGroupTotalMemberNum != undefined
                ? i.exitChatGroupTotalMemberNum
                : 0
            }}
          </div>
          <div class="item">
            当前群人数：{{
              i.chatGroupMemberTotalNum != null ||
              i.chatGroupMemberTotalNum != undefined
                ? i.chatGroupMemberTotalNum
                : 0
            }}
          </div>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
// import {
//   statisticsListApi,
//   getTagList,
//   getGroupMessage,
//   addTagItems,
//   deleteGroupTags,
// } from "../../api/group/index.js";
import { statisticsListApi } from "@/api/group/code.js";
import groupChatView from "./components/groupChatView";
import GroupActiveCodeStatisticsDetail from "./components/groupActiveCodeStatisticsDetail.vue";
import Tag from "./tag.vue";
import dayjs from "dayjs";
export default {
  name: "CusChatSupervise",
  components: {
    groupChatView,
    Tag,
    GroupActiveCodeStatisticsDetail,
  },
  data() {
    return {
      /** 存储活码统计数据 */
      tableData: [],
      /** 分页参数 */
      pageparm: {
        pageNum: 1,
        pageSize: 20,
        total: 10,
      },
      /** 搜索数据 */
      searchParams: {
        total: 0,
        page: 1,
        size: 20,
        /** 活码名称 */
        name: "",
        /** 进群方式 */
        joinWay: "",
        /** 使用场景 */
        sceneName: "",
        /** 创建时间-开始 */
        startTime: "",
        /** 创建时间-结束 */
        endTime: "",
        /** 创建人 */
        creatorName: "",
        /** 使用员工 */
        staffName: "",
        /** 类型 */
        // qrType: "",
        /** 状态 1:启用 0:禁用 */
        status: "",
      },
      /** 控制显示隐藏 */
      groupActiveCodeStatisticsDetailShow: false,
      /** 分页条数 */
      pageSizes: [20, 50, 100, 200, 500],
      /** 创建时间数据 */
      date: null,
      /** 明细数据 */
      checkDetailList: [],
      /** 禁止选中未来日期 */
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  methods: {
    /** 获取群活码 */
    geDatatList() {
      statisticsListApi(
        this.searchParams,
        localStorage.getItem("Authorization")
      ).then((res) => {
        // console.log("res");
        // console.log(res);
        if (res && res.error && res.error.code == 200) {
          if (
            res &&
            res.data &&
            res.data.records &&
            res.data.records.length > 0
          ) {
            this.tableData = res.data.records;
            this.searchParams.total = Number(res.data.total);
            // this.pageparm.pageNum = this.searchParams.current;
            // this.pageparm.pageSize = this.searchParams.size;
            // this.total = res.data.total
          } else {
            this.tableData = [];
            this.searchParams.total = 0;
          }
        }
      });
    },

    /** 点击查看明细触发 */
    viewDetail(row) {
      this.groupActiveCodeStatisticsDetailShow = true;
      this.$nextTick(() => {
        this.$refs.GroupActiveCodeStatisticsDetail.init(row);
      });
    },

    /** 创建时间变化触发 */
    selectBindStatus() {
      if (this.date != null) {
        this.searchParams.startTime = dayjs(this.date[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.searchParams.endTime =
          dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.searchParams.startTime = "";
        this.searchParams.endTime = "";
      }
      this.searchParams.page = 1;
      this.geDatatList();
    },
    /** 排序变化触发 */
    sortChange(column, prop, order) {
      if (!column.order) {
        this.searchParams.sort = "";
        this.searchParams.asc = false;
      } else {
        this.searchParams.sort = column.prop;
        this.searchParams.asc = column.order === "ascending";
        this.geDatatList();
      }
    },

    /** 关闭弹窗触发 */
    close() {
      this.groupActiveCodeStatisticsDetailShow = false;
    },
    // geDatatList(parameter) {
    //   geDatatList(parameter, localStorage.getItem("Authorization")).then((res) => {
    //     if (res.error.code == 200) {
    //       if (res.data.rows.length > 0) {
    //         this.tableData = res.data.rows;
    //         this.pageparm.total = res.data.count;
    //         this.pageparm.pageNum = this.searchParams.pageNum;
    //         this.pageparm.pageSize = this.searchParams.pageSize;
    //       } else {
    //         this.tableData = [];
    //       }
    //     }
    //   });
    // },
    /** 分页回调 */
    callBack(parm) {
      this.searchParams.pageNum = parm.currentPage;
      this.searchParams.pageSize = parm.pageSize;
      this.geDatatList();
    },

    /** 页码改变回调 */
    currentChange(parm) {
      console.log("sdfsdfsdfdfgtre", parm);
      this.searchParams.page = parm;

      this.geDatatList();
    },

    /** 页数改变回调 */
    sizeChange(parm) {
      console.log("sdfsdfsdfdfgtre1", parm);
      this.searchParams.pageSize = parm;

      this.geDatatList();
    },
  },

  /** 生命周期 */
  created() {
    /** 获取活码统计数据 */
    this.geDatatList();
  },
};
</script>
<style lang="scss" scoped>
.groupActiveCodeStatistics-container {
  .search-wrap {
  }
  .list {
    display: flex;
    margin-top: 8px;
    .item {
      margin-right: 40px;
    }
  }
  .title {
    margin-top: 10px;
    font-weight: bold;
  }
  .staff-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }
}
</style>
